import type { DeploymentResponse } from "@nexus/types"
import type { PayloadAction } from "@reduxjs/toolkit"

import type { EmbedChatInitPhase, EmbedChatState } from "../embedTypes"

/**
 * Update initialization phase
 */
export const updateEmbedInitPhase = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string; phase: EmbedChatInitPhase }>
) => {
  const { chatId, phase } = action.payload
  const chat = state.chats[chatId]

  if (chat) {
    chat.initializationPhase = phase
  }
}

/**
 * Set initialization error
 */
export const setEmbedInitError = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string; error: string }>
) => {
  const { chatId, error } = action.payload
  const chat = state.chats[chatId]

  if (chat) {
    chat.initializationPhase = "error"
    chat.initializationError = error
  }
}

/**
 * Update embed deployment (same shape as API).
 */
export const updateEmbedMetadata = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string; metadata: DeploymentResponse }>
) => {
  const { chatId, metadata } = action.payload
  const chat = state.chats[chatId]

  if (chat) {
    chat.deployment = metadata
  }
}

/**
 * Reset embed session (for preview mode)
 */
export const resetEmbedSession = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string }>
) => {
  const { chatId } = action.payload
  const chat = state.chats[chatId]

  if (chat) {
    chat.messages = []
    chat.streamingMessages = {}
    chat.initializationPhase = "idle"
    chat.initializationError = null
  }
}

/**
 * Remove embed session
 */
export const removeEmbedSession = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string }>
) => {
  const { chatId } = action.payload
  delete state.chats[chatId]

  if (state.activeChatId === chatId) {
    state.activeChatId = null
  }
}
